import Swal from 'sweetalert2';

// ---------------------------------------------------------------------------
// Alertlar moduli
// ---------------------------------------------------------------------------
// Barcha motivatsion / hayajonlantiruvchi alertlar shu joydan boshqariladi.
// Bu yerda faqat ko'rinish (UI) va matnlar saqlanadi — qachon chaqirilishi
// esa chaqiruvchi kod (masalan api.updateUserData) tomonidan hal qilinadi.
// Yangi alert qo'shmoqchi bo'lsangiz, shu faylga funksiya qo'shing.
// ---------------------------------------------------------------------------

const BRAND = '#00ad4d';

/**
 * Umumiy chiroyli, brend uslubidagi motivatsion alert ko'rsatadi.
 * @param {{emoji:string, title:string, text:string, badge?:string, confirmText?:string}} options
 */
function showMotivationAlert({ emoji, title, text, badge, confirmText = 'Davom etaman! 💚' }) {
  Swal.fire({
    html: `
      <div style="font-size:64px;line-height:1;margin-bottom:12px;">${emoji}</div>
      <h2 style="margin:0 0 10px;font-size:24px;font-weight:800;color:#0b3d24;">${title}</h2>
      <p style="margin:0 0 16px;font-size:16px;color:#3a4a42;line-height:1.5;">${text}</p>
      ${badge
        ? `<div style="display:inline-flex;align-items:center;gap:8px;background:#e8f9ef;color:${BRAND};font-weight:700;padding:8px 18px;border-radius:999px;font-size:18px;">${badge}</div>`
        : ''}`,
    showConfirmButton: true,
    confirmButtonText: confirmText,
    confirmButtonColor: BRAND,
    background: '#ffffff',
    backdrop: 'rgba(0, 173, 77, 0.15)',
    allowOutsideClick: true,
  });
}

// Faol kunlar bo'yicha bosqichli (milestone) tabrik xabarlari.
const ACTIVE_DAYS_MILESTONES = {
  1: { emoji: '🌱', title: 'Ajoyib boshlanish!', text: "Bugun siz ingliz tilini o'rganish sari birinchi qadamni tashladingiz. Har bir buyuk yo'l bitta qadamdan boshlanadi!" },
  3: { emoji: '🔥', title: '3 kun ketma-ket!', text: "Odat shakllanmoqda! Siz allaqachon ko'pchilikdan oldindasiz. Shu ruhda davom eting!" },
  7: { emoji: '⭐', title: 'Bir haftalik chempion!', text: "Butun bir hafta davomida tilni o'rgandingiz! Bu — haqiqiy intizom. Sizdan faxrlanamiz!" },
  14: { emoji: '💪', title: "2 hafta — zo'r natija!", text: "Ikki hafta uzluksiz mehnat! Miyangiz endi inglizcha o'ylashga o'rgana boshladi." },
  30: { emoji: '🏆', title: '30 kun — bir oy!', text: "Bir oy davomida siz bizning platformada til o'rgandingiz! Bu — g'alaba. Endi to'xtamang, orzuingizga yaqinlashyapsiz!" },
  50: { emoji: '🚀', title: '50 kun!', text: "Ellik kunlik izchillik! Siz endi oddiy o'quvchi emassiz — siz haqiqiy bilim izlovchisiz!" },
  100: { emoji: '👑', title: '100 kun — afsona!', text: "Yuz kun! Bu darajaga juda kam odam yetadi. Siz o'zingizga bo'lgan ishonchni isbotladingiz. Tabriklaymiz, chempion!" },
};

/**
 * Foydalanuvchining faol kunlari ortganda tabrik alertini ko'rsatadi.
 * @param {number} days - joriy faol kunlar soni
 */
export function celebrateActiveDays(days) {
  const milestone = ACTIVE_DAYS_MILESTONES[days] || {
    emoji: '🎉',
    title: `${days} kunlik faollik!`,
    text: `Siz allaqachon ${days} kun davomida bizning platformada ingliz tilini o'rganyapsiz. Har bir kun sizni maqsadingizga yaqinlashtiryapti — davom eting!`,
  };

  showMotivationAlert({
    ...milestone,
    badge: `🗓️ ${days} faol kun`,
  });
}

/**
 * Uzoq vaqt saytga kirmagan foydalanuvchini iliq kutib oladigan alert.
 * @param {number} daysAway - oxirgi tashrifdan beri o'tgan kunlar soni
 * @param {number} [activeDays] - foydalanuvchining umumiy faol kunlari (ixtiyoriy)
 */
export function welcomeBackAfterAbsence(daysAway, activeDays) {
  let title;
  let text;

  if (daysAway >= 30) {
    title = 'Sizni juda sog\'indik! 🤍';
    text = `Oradan ${daysAway} kun o'tibdi. Ingliz tili sizni kutyapti — hech narsa yo'qolmadi, bugundan yana boshlaymiz. Eng kuchli o'quvchilar — qaytib keladiganlardir!`;
  } else if (daysAway >= 7) {
    title = 'Qaytib kelganingizdan xursandmiz!';
    text = `${daysAway} kunlik tanaffusdan so'ng yana shu yerdasiz. Bu — kuchli iroda belgisi. Keling, to'xtagan joyimizdan davom etamiz!`;
  } else {
    title = 'Xush kelibsiz! 👋';
    text = `Sizni yana ko'rganimizdan xursandmiz. Bugun ham bir necha yangi so'z o'rganamizmi?`;
  }

  showMotivationAlert({
    emoji: '👋',
    title,
    text,
    badge: activeDays ? `🗓️ Jami ${activeDays} faol kun` : undefined,
    confirmText: "O'rganishni boshlayman! 🚀",
  });
}
